
export default {
  'placesCarousel': {
    'layer': 'Couche',
    'lat': 'Lat.',
    'lon': 'Lon.',
    'notAvailable': 'Pas disponible',
    'placeDetails': 'Détails du lieu',
    'next': 'Bloc suivant',
    'prev': 'Bloc précédent',
    'directionsTo': 'Itinéraire vers',
    'distance': 'Distance',
    'distanceFromLocationMarkedOnTheMap': 'Distance approximative de l\'emplacement indiqué sur la carte',
    'selectPlace': 'Sélectionner'
  }
}
